/**
 * @generated SignedSource<<f43e543634e15328774d6a202fa6af12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IndustryField_Query$variables = Record<PropertyKey, never>;
export type IndustryField_Query$data = {
  readonly industries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type IndustryField_Query = {
  response: IndustryField_Query$data;
  variables: IndustryField_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "IndustryConnection",
    "kind": "LinkedField",
    "name": "industries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IndustryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Industry",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "industries(first:100)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndustryField_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IndustryField_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fc5eb1a110ce8e12095242bc239c9f1e",
    "id": null,
    "metadata": {},
    "name": "IndustryField_Query",
    "operationKind": "query",
    "text": "query IndustryField_Query {\n  industries(first: 100) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cdc9e0b038119bc243f92934ede7c2ca";

export default node;
